import React from "react";
import { getDataSource } from "../../services/api";
import { handleImageError } from "../../utils/common";

const TopCandidateDetails = ({ t, data, language }) => {
  const {
    topCandidateImageUrl,
    party,
    topCandidateTimeline,
    moreInfoUrl,
    topCandidateName,
  } = data;

  const navigateToMoreInfo = () => {
    window.open(moreInfoUrl, "_blank");
  };
  return (
    <div className="bg-white pt-0 pb-7" id="top-candidate-details">
      <div className="flex flex-row items-end px-5 md:hidden">
        <img
          src={`${getDataSource()}/top-candidates/${topCandidateImageUrl}.webp`}
          alt={party}
          onError={handleImageError}
          width={93}
        />
        <span className="text-22 font-medium ml-5 md:text-32">
          {t("topCandidateTitle")}
        </span>
      </div>
      <span className="text-22 font-medium ml-5 md:text-32 hidden md:block">
        {t("topCandidateTitle")}
      </span>
      <div className="hidden md:block h-[1px] bg-black bg-opacity-40 mb-7 mx-5"></div>
      <div className="flex flex-row items-start px-5 hidden md:flex">
        <img
          src={`${getDataSource()}/top-candidates/${topCandidateImageUrl}.webp`}
          alt={party}
          onError={handleImageError}
          width={93}
          className="ml-4 mr-8"
        />
        <div className=" py-5 px-5 bg-wort flex flex-row">
          <div className="flex-grow border border-r-[#E88B00] border-r-4 mr-5"></div>
          <div className="flex-grow w-full">
            {topCandidateTimeline
              .sort((a, b) => b.year - a.year)
              .filter((item) => item.lang === language)
              .map((item) => (
                <div className="mt-9" key={item.year}>
                  <div>
                    {/* <Circle /> */}
                    <span className="text-22 font-extrabold mr-4">
                      {item.year}
                    </span>
                    <span className="text-lg font-medium leading-6">
                      {item.event.split(".")[0]}
                    </span>
                  </div>
                  <span className="">
                    {item.event.split(".").slice(1).join(".")}
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className=" py-5 px-5 bg-wort flex flex-row md:hidden">
        <div className="flex-grow border border-r-[#E88B00] border-r-4 mr-5"></div>
        <div className="flex-grow w-full">
          {topCandidateTimeline
            .sort((a, b) => b.year - a.year)
            .filter((item) => item.lang === language)
            .map((item) => (
              <div className="mt-9" key={item.year}>
                <div>
                  {/* <Circle /> */}
                  <span className="text-22 font-extrabold mr-4">
                    {item.year}
                  </span>
                  <span className="text-lg font-medium leading-6">
                    {item.event.split(".")[0]}
                  </span>
                </div>
                <span className="">
                  {item.event.split(".").slice(1).join(".")}
                </span>
              </div>
            ))}
        </div>
      </div>
      {moreInfoUrl && (
        <button
          className="bg-primary text-white text-16 font-medium uppercase py-2 px-5 mt-5 mb-10 rounded mx-auto block md:ml-[160px]"
          onClick={navigateToMoreInfo}
        >
          {t("moreInfo")} {topCandidateName}
        </button>
      )}
    </div>
  );
};

export default TopCandidateDetails;
